import Vue from 'vue'
import Router from 'vue-router'
// import indexMain from '@/components/indexMain'

Vue.use(Router)

export const router = new Router({
  routes: [
    {
      path: '/',
      component: () => import('@/components/indexMain'),
      children: [
        {
          path: '/',
          name: 'homeMain',
          component: () => import('@/components/homeMain'),
        },{
          path: '/company',
          name: 'company',
          component: () => import('@/components/subPage/company'),
        },
        {
          path: '/case',
          name: 'case',
          component: () => import('@/components/subPage/case'),
        },
        {
          path: '/prodect',
          name: 'prodect',
          component: () => import('@/components/subPage/prodect'),
        },
        {
          path: '/service',
          name: 'service',
          component: () => import('@/components/subPage/service'),
        },
        {
          path: '/construction',
          name: 'construction',
          component: () => import('@/components/subPage/construction'),
        },
        {
          path: '/newsList',
          name: 'newsList',
          component: () => import('@/components/subPage/newsList'),
        },
        {
          path: '/contactUs',
          name: 'contactUs',
          component: () => import('@/components/subPage/contactUs'),
        },
        {
          path: '/newsDetail',
          name: 'newsDetail',
          component: () => import('@/components/subPage/newsDetail'),
        },
        
        {
          path: '/about',
          name: 'about',
          component: () => import('@/components/about'),
        },{
          path: '/product',
          name: 'product',
          component: () => import('@/components/product'),
        }
        // ,{
        //   path: '/case',
        //   name: 'case',
        //   component: () => import('@/components/case'),
        // }
        ,{
          path: '/news',
          name: 'news',
          component: () => import('@/components/news'),
        },{
          path: '/contact',
          name: 'contact',
          component: () => import('@/components/contact'),
        },{
          path: '/newDetails',
          name: 'newDetails',
          component: () => import('@/components/subUnit/newDetails'),
        }

      ]

    },
    {
      path: '/backHome',
      name: 'backHome',
      component: () => import('@/components/backHome'),

    },
    {
      path: '/backLogin',
      name: 'backLogin',
      component: () => import('@/components/backLogin'),

    }
  ]
})
// 全局路由守卫
router.beforeEach((to, from, next) => {
  // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
  // A跳转到B，B页面停留在A页面的滚动位置；解决方法：将scrollTop设置为0
  window.scroll(0, 0);
  
  next();
});



// WEBPACK FOOTER //
// ./src/router/index.js